<template>

	<!--Confirmation Requests-->
	<div class="basic-box cabinet__basic-box">
		<div class="basic-box__title">Запросы на подтверждение</div>

		<notification-item :event="event" v-for="event in value" :key="event._id"></notification-item>

		<div v-if="!value.length">У Вас еще не было запросов</div>
	</div>
	<!--Confirmation Requests End-->

</template>

<script>
	import NotificationItem from '@/components/NotificationItem.vue'

	export default {
		name: 'Notification',
		props: ['value'],
		components: {NotificationItem}
	}
</script>



// WEBPACK FOOTER //
// Notification.vue?f2bf177c